import Layout from "../../components/Layout"
import { Stack } from "@mui/material"
import { Layers, PlayCircleOutlineOutlined, Info, Videocam, DocumentScanner, AspectRatio } from "@mui/icons-material"
import { Route, Routes } from "react-router-dom"
import SupportoDettaglio from "./SupportoDettaglio"
import { useParams } from "react-router-dom"
import { PageTitle } from "../../components/PageTitle"
import { useTranslation } from "react-i18next"
import Documenti from "../Documenti"
import FilesDigitali from "../FilesDigitali"
import Revisioni from "../Revisioni"
import Rimediazioni from "../Rimediazioni"
import SequenzeList from "../../pages/SequenzeList"
import { useSupporto } from "../../hooks/supporti"
import { useAuth } from "../../auth"

export default function Supporto() {
  const { supportoId: id } = useParams()
  const { t, i18n } = useTranslation()
  const { data: supporto } = useSupporto(parseInt(id as string))
  const lang = i18n.language

  const { user } = useAuth()

  return (
    <Layout>
      <Stack sx={{ height: "100%", overflow: "hidden" }}>
        <PageTitle
          padding
          border
          title={supporto?.segnatura || ""}
          breadcrumbs={[
            {
              label: t("general.supporti"),
              iconType: Layers,
              to: `/${lang}/supporti`,
            },
            {
              label: supporto?.segnatura || "",
            },
          ]}
          tabs={
            user?.ruolo !== "consultazione"
              ? [
                  {
                    label: t("general.dettaglio"),
                    iconType: Info,
                    to: `/${lang}/supporti/${id}`,
                  },
                  {
                    label: t("general.documenti"),
                    iconType: PlayCircleOutlineOutlined,
                    to: `/${lang}/supporti/${id}/documenti`,
                  },
                  {
                    label: t("general.rimediazioni"),
                    iconType: AspectRatio,
                    to: `/${lang}/supporti/${id}/rimediazioni`,
                  },
                  {
                    label: t("general.revisioni"),
                    iconType: DocumentScanner,
                    to: `/${lang}/supporti/${id}/revisioni`,
                  },

                  {
                    label: t("general.files"),
                    iconType: Videocam,
                    to: `/${lang}/supporti/${id}/files`,
                  },

                  {
                    label: t("general.sequenze"),
                    iconType: Videocam,
                    to: `/${lang}/supporti/${id}/sequenze`,
                  },
                ]
              : [
                  {
                    label: t("general.dettaglio"),
                    iconType: Info,
                    to: `/${lang}/supporti/${id}`,
                  },
                  {
                    label: t("general.documenti"),
                    iconType: PlayCircleOutlineOutlined,
                    to: `/${lang}/supporti/${id}/documenti`,
                  },
                {
                    label: t("general.files"),
                    iconType: Videocam,
                    to: `/${lang}/supporti/${id}/files`,
                  },

                  {
                    label: t("general.sequenze"),
                    iconType: Videocam,
                    to: `/${lang}/supporti/${id}/sequenze`,
                  },
                ]
          }
        />

        <Routes>
          <Route index element={<SupportoDettaglio />}></Route>
          <Route path={`rimediazioni`} element={<Rimediazioni supportoId={Number(id)} />}></Route>
          <Route path={`documenti`} element={<Documenti supportoId={Number(id)} />}></Route>
          <Route path={`files`} element={<FilesDigitali supportoId={Number(id)} />}></Route>
          <Route path={`revisioni`} element={<Revisioni supportoId={Number(id)} />}></Route>
          <Route path={`sequenze`} element={<SequenzeList supportoId={Number(id)} />}></Route>
        </Routes>
      </Stack>
    </Layout>
  )
}
